import { render, staticRenderFns } from "./TrialQuestion.vue?vue&type=template&id=7bd387c7&scoped=true"
import script from "./TrialQuestion.vue?vue&type=script&lang=js"
export * from "./TrialQuestion.vue?vue&type=script&lang=js"
import style0 from "./TrialQuestion.vue?vue&type=style&index=0&id=7bd387c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd387c7",
  null
  
)

export default component.exports